/*
 * Copyright 2018-present Evernote Corporation. All rights reserved.
 */
import { BrokerOrBridge, SubscriberHandler, RegistrantHandler } from 'ion-types';
import Registry from 'ion-registry';

class BrokerFacade implements BrokerOrBridge {
  subscribe(
    topics: string,
    handler: SubscriberHandler,
    replayMessage?: boolean
  ): () => void {
    return Registry().broker.subscribe(topics, handler, replayMessage);
  }

  publish(topics: string, type: string | undefined, data: any, saveMessage?: boolean) {
    Registry().broker.publish(topics, type, data, saveMessage);
  }

  register(topics: string, handler: RegistrantHandler): () => void {
    return Registry().broker.register(topics, handler);
  }

  call(topicPath: string, arg?: any): Promise<any> {
    return Registry().broker.call(topicPath as any, arg);
  }

  clearTopics(topics: string): void {
    return Registry().broker.clearTopics(topics);
  }
}

const facade: BrokerOrBridge = new BrokerFacade();
export default facade;
